import React, { useState, useEffect, useRef } from "react";
import { Table, Input, Tag } from "antd";
import styles from "./workflow.module.scss";
import KoIcon from '@kwapio/icons';
import KoButton from "packages/button";
import { KoDescription, KoText, KoTitle } from "packages/typography";
import KoTag from "packages/tag";
import { TEMPLATECONTNET } from "./contstant";
import KoImage from "packages/image";

const ActivityEditor = ({ data, onChange, readOnly, isDefault, height, setTemplateModal, customAction }) => {
  const [activity, setActivity] = useState(data?.activityTypes || []);
  const tableRef = useRef(null);
  let details = TEMPLATECONTNET[data?.templateId] || {};
  useEffect(() => {
    setActivity(data?.activityTypes || []);
  }, [data]);

  const handleLabelChange = (value, newLabel) => {
    const updatedActivity = activity?.map(status => (status.value === value ? { ...status, label: newLabel } : status));
    const filteredActivities = updatedActivity.filter(item => item.label && item.label.trim() !== "");

    setActivity(filteredActivities);

    let template = data;
    template.activityTypes = filteredActivities;
    onChange && onChange(template);
  };

  // const handleColorChange = (value, newColor, key) => {
  //   const updatedActivity = activity?.map(status => {
  //     if (status.value === value) {
  //       const newRGBA = `rgba(${newColor.metaColor.r}, ${newColor.metaColor.g}, ${newColor.metaColor.b}, 0.16)`;
  //       const updatedStatus = { ...status, [key]: newRGBA };
  
  //       if (key === "background") {
  //         updatedStatus.color = `rgba(${newColor.metaColor.r}, ${newColor.metaColor.g}, ${newColor.metaColor.b}, .9)`;
  //       }
  
  //       return updatedStatus;
  //     }
  //     return status;
  //   });
  
  //   setActivity(updatedActivity);
  //   let template = data;
  //   template.activityTypes = updatedActivity;
  //   onChange && onChange(template);
  // };

  const handleAddStatus = () => {
    const newStatus = {
      label: "New Status",
      value: activity?.length >0  ? activity.length + 1 : 1,
      name: "New Status",
      background: "rgba(200, 200, 200, 0.16)",
      color: "#000000",
      icon: "Avatar1Filled",
      nextStatuses: []
    };
    const updatedActivity = [...activity, newStatus].map((status, index) => ({
      ...status,
      value: index + 1
    }));
  
    setActivity(updatedActivity);
    let template = data;
    template.activityTypes = updatedActivity;
    onChange && onChange(template);
  
    setTimeout(() => {
      if (tableRef.current) {
        tableRef.current.scrollTo({ top: tableRef.current.scrollHeight + 500, behavior: "smooth" });
      }
    }, 100);
  };

  const handleDeleteStatus = (value) => {
    const updatedActivity = activity?.filter(status => status.value !== value)
      .map((status, index) => ({
        ...status,
        value: index + 1
      }));
    setActivity(updatedActivity);
    let template = data;
    template.activityTypes = updatedActivity;
    onChange && onChange(template);
  };

  const handleTableChange = (newWorkflow) => {
    const updatedActivity = newWorkflow.map((status, index) => ({
      ...status,
      value: index + 1 // Update index value based on new order
    }));
    setActivity(updatedActivity);
    let template = data;
    template.activityTypes = updatedActivity;
    onChange && onChange(template);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "value",
      key: "value",
      width: 50,
      fixed: "left",
      editable: isDefault ? false : true,
      render: (text, record) => (
        <KoTag iscount={true} value={text} />
      )
    },
    {
      title: "Activity Type",
      dataIndex: "label",
      key: "label",
      fixed: "left",
      editable: isDefault ? false : true,
      render: (text, record) => (
        <Input disabled={isDefault} value={text} onChange={e => handleLabelChange(record.value, e.target.value)} />
      )
    },
    // {
    //   title: "Background",
    //   dataIndex: "background",
    //   key: "background",
    //   align: "center",
    //   width: 130,
    //   editable: isDefault ? false : true,
    //   render: (background, record) => (
    //     <ColorPicker disabled={isDefault}  defaultFormat="rgba" value={background} onChange={c => handleColorChange(record.value, c, "background")} />
    //   )
    // },
    {
      title: "Preview",
      key: "preview",
      width: 100,
      editable: isDefault ? false : true,
      render: (_, record) => (
        <Tag style={{ background: 'transparent', color: '#666', padding: "3px 8px" , border:0}}>
          <KoIcon name={record.icon} />
          {record.label}
        </Tag>
      )
    },
    {
      title: "",
      key: "actions",
      width: 50,
      fixed: "right",
      align: "right",
      render: (_, record) => (
        <KoButton disabled={isDefault} icon={ <KoIcon name="DeleteOutlined" />} onClick={() => handleDeleteStatus(record.value)} />
      )
    }
  ];

  return (
    readOnly ? <div className={styles.readOnly}>
      <div className={styles.leftPannel}>
        <div className={styles.header}>
          <KoTitle className={styles.title} text={details?.title} level={2} />
          <KoTitle className={styles.subTitle} text={details?.subTitle} level={5} />
        </div>
        <div className={styles.contentWrapper}>
         
          {
            details?.rows?.map((row, index) => (
              
              <div className={styles.content} key={index}>
                {(index === 0 || index === 2) && <div className={styles.icon}>
                  <KoImage src={`https://raw.githubusercontent.com/kwapio/logo/refs/heads/main/templates/${data.templateId}/${index+1}.svg
`} width={170} height={170}/>
                </div>}
                <div className={styles.description}>
                  <KoDescription text={row?.description} />
                </div>
                {index ===1 && <div className={styles.icon}>
                  <KoImage src={`https://raw.githubusercontent.com/kwapio/logo/refs/heads/main/templates/${data.templateId}/2.svg
`} width={170} height={170}/>
                </div>}
              </div>
            ))
          }
        </div>
      </div>
      <div className={styles.rightPannel}>
        <div className={styles.rightContentWrapper}>
          <div className={styles.rightContent}>
            <div className={styles.workflow}>
              <KoTitle text={"Workflow"} level={2}/>
              <ul>
                {activity?.map((status, index) => (
                  <li key={index}>
                    <div className={styles.status} style={{background: status.background, color: status.color}}>
                      <KoText text={status.label} style={{color: status.color}}/>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.issueTypes}>
              <KoTitle text={"Activity types"} level={2}/>
              <ul>
                {data?.activityTypes?.map((status, index) => (
                  <li key={index}>
                    <div className={styles.issues} style={{background: status.background, color: status.color}}>
                      <KoIcon name={status.icon} width={20} height={20}/>
                      <KoText text={status.label} style={{color: status.color}}/>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        {/* <div className={styles.rightFooter}>
          <div className={styles.rightFooterContent}>
            <KoTitle text={"System Features"} level={2}/>
            <ul>
              {details?.systemFeatures?.map((status, index) => (
                <li key={index}>
                  <div className={styles.issues} style={{background: status.background, color: status.color}}>
                    <KoIcon name={status.icon} width={20} height={20}/>
                    <KoText text={status.title} style={{color: status.color}}/>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div> */}
      </div>

    </div> : <div className={`${styles.wrapper}`}>
      {!isDefault && <div className={styles.header}>
        <KoTitle text={data?.name || "Activity"} level={5} />
        <div className={styles.actions}>
          <KoButton label="New Type" type="primary" icon={ <KoIcon color="#FFF" name="PlusOutlined"/>}  onClick={() => handleAddStatus()} />
          {customAction?.length > 0 && customAction.map((action, index) => (
            <KoButton key={index} {...action} />
          ))}
        </div>
      </div>}
      {}
      <Table
        dataSource={activity?.filter(status => status.label.trim() !== "")} // Filter out empty rows
        pagination={false}
        ref={tableRef}
        columns={columns}
        size="small"
        scroll={{
          x: 'max-content',
          y: 'calc(100vh - 40rem)'
        }}
        rowKey="value"
        onChange={(pagination, filters, sorter, extra) => handleTableChange(extra.currentDataSource)}
      />
    </div>
  );
};

export default ActivityEditor;
